module.exports = __webpack_public_path__ + "static/media/discount.be2d40e8.svg";